module.exports = __webpack_public_path__ + "assets/link.c9d75dcf.svg";